import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import icon from 'flarum/common/helpers/icon';
import type Mithril from 'mithril';

export default class CustomSignUpModal extends Modal {
  className() {
    return 'CustomSignUpModal Modal--small';
  }

  title() {
    return 'Регистрация на Prokrasivoe';
  }

  content() {
    return (
      <div className="Modal-body">
        <p>
          <strong>Prokrasivoe</strong> — закрытая платформа для косметологов, предоставляющая доступ к эксклюзивным
          материалам, обсуждениям и возможностям для профессионального развития.
        </p>
        <p>Регистрация возможна только через <strong>Prokrasivoe.ru</strong>. После регистрации ваш аккаунт создастся автоматически.</p>
        <Button className="Button Button--primary Button--block" onclick={() => window.open('https://prokrasivoe.ru/register', '_blank')}>
          Зарегистрироваться на Prokrasivoe.ru
        </Button>
      </div>
    );
  }

  hide() {
    app.modal.close();
  }
}
